import { AppBar, Tab } from "@mui/material";
import { withStyles, WithStyles } from "@mui/styles";
import * as api from "api/Core";
import { DashboardStyleClasses, TabLargeStyle } from "assets/jss/common-styles";
import { AppBarTabs } from "components/AppTabs";
import MuiContainer from "components/MuiExtras/MuiContainer";
import * as React from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import Session from "services/Session";
import UserEvolutionKnowledge from "views/Dashboards/UserEvolutionDashboard/UserEvolutionKnowledge";
import UserEvolutionParticipation from "views/Dashboards/UserEvolutionDashboard/UserEvolutionParticipation";
import UserEvolutionPublication from "views/Dashboards/UserEvolutionDashboard/UserEvolutionPublication";

/////////////////////////////////////////////////////////////////////////////////////

interface IState {
    currentTab: UserEvolutionDashboardTabOptions;
    hasKnowledgeDatabase: boolean;
}

export interface UserEvolutionDashboardProps {
    tab?: UserEvolutionDashboardTabOptions;
}

export type CommonProps = UserEvolutionDashboardProps & WithStyles<typeof DashboardStyleClasses> & WithTranslation;

export enum UserEvolutionDashboardTabOptions { Participation, Publication, Knowledge }

/////////////////////////////////////////////////////////////////////////////////////

class UserEvolutionDashboard extends React.PureComponent<CommonProps, IState> {

    constructor(props: CommonProps) {
        super(props);

        const initialTab: UserEvolutionDashboardTabOptions = props.tab || UserEvolutionDashboardTabOptions.Participation;

        this.state = {
            currentTab: initialTab,
            hasKnowledgeDatabase: false
        };
    }

    ///
    private handleTabSelection = (event: React.ChangeEvent<{}>, value: any) => {
        this.setState({ currentTab: value });
    };

    ///
    private renderFormMenuBar(): JSX.Element {

        return (
            <MuiContainer margin="dense">
                <AppBar position="static" color="primary"  >
                    <AppBarTabs centered value={this.state.currentTab} onChange={this.handleTabSelection}>
                        <Tab key={UserEvolutionDashboardTabOptions.Participation} value={UserEvolutionDashboardTabOptions.Participation} label={this.props.t<string>("Views.Dashboards.UserEvolution.Index.TabParticipation")} style={TabLargeStyle} />
                        <Tab key={UserEvolutionDashboardTabOptions.Publication} value={UserEvolutionDashboardTabOptions.Publication} label={this.props.t<string>("Views.Dashboards.UserEvolution.Index.TabPublication")} style={TabLargeStyle} />
                        {
                            this.state.hasKnowledgeDatabase &&
                            <Tab key={UserEvolutionDashboardTabOptions.Knowledge} value={UserEvolutionDashboardTabOptions.Knowledge} label={this.props.t<string>("Views.Dashboards.UserEvolution.Index.TabKnowledge")} style={TabLargeStyle} />
                        }
                    </AppBarTabs>
                </AppBar>
            </MuiContainer>
        );
    }

    ///
    componentDidMount() {
        api.getUserEvolutionHasKnowledge(Session.user.id)
            .then((hasKnowledgeDatabase) => {
                this.setState({ hasKnowledgeDatabase });
            });
    }

    ///
    render() {
        return (
            <div className={this.props.classes.dashboardLargeContainer}>

                {
                    this.renderFormMenuBar()
                }

                {
                    this.state.currentTab == UserEvolutionDashboardTabOptions.Publication
                        ? <UserEvolutionPublication userId={Session.user.id} {...this.props} />
                        : this.state.currentTab == UserEvolutionDashboardTabOptions.Participation
                            ? <UserEvolutionParticipation userId={Session.user.id} {...this.props} />
                            : <UserEvolutionKnowledge userId={Session.user.id} {...this.props} />
                }

            </div>
        );
    }
}

export default withTranslation()(withStyles(DashboardStyleClasses)(UserEvolutionDashboard));